/* global trapFocus, removeTrapFocus */
/**
 * Reusable slide-in sidebar. Multiple independent instances can exist on the
 * same page — each is opened by a trigger whose `aria-controls` matches this
 * element's `id` (see snippets/sidebar-trigger.liquid). trapFocus/removeTrapFocus
 * come from assets/global.js, loaded globally via layout/theme.liquid.
 */

class SidebarDrawer extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.sidebar__panel');
    this.overlay = this.querySelector('.sidebar__overlay');
    this.closeButton = this.querySelector('.sidebar__close');
    this.trigger = null;

    this.closeButton?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') this.close();
    });
  }

  open(trigger) {
    this.trigger = trigger || null;
    this.setAttribute('open', '');
    this.classList.add('sidebar--open');
    trapFocus(this, this.closeButton);
  }

  close() {
    this.removeAttribute('open');
    this.classList.remove('sidebar--open');
    removeTrapFocus(this.trigger);
    this.trigger = null;
  }
}

customElements.define('sidebar-drawer', SidebarDrawer);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[aria-controls]');
  if (!trigger) return;

  const target = document.getElementById(trigger.getAttribute('aria-controls'));
  if (target instanceof SidebarDrawer) target.open(trigger);
});
